import { Loader } from '../_helpers/Loader/Loader';
import * as React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { __ } from '@bart.sk-eshop/react-i18n';
import {
  formatPrice,
  getGiftCartRemain,
  getGiftWebContentIdFromSettings,
  prop,
} from '../../utilities';
//import { RadioStyled } from '../_helpers/form/Radio';
//import { Row } from '../../theme/libraries/grid';
import {
  /*loadProduct, */ setArticleModal,
} from '../../containers/App/actions';
//import { Gift } from '../../library/Gifts';
import { updateCart } from '../../containers/Cart/actions';
//import { Link } from 'react-router';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import Overlay from '../_helpers/Overlay/Overlay';
import IconLazy from '../_helpers/Icon/IconLazy';

import loadable from '@loadable/component';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color.white};
  padding: ${rem(10)} ${rem(20)};
  margin-top: ${rem(2)};
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  font-size: ${rem(14)};

  ${({ theme }) => theme.media('sm')} {
    border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
    margin-top: 0;
    margin-bottom: ${rem(15)};
  }
`;

/*
const RowStyled = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  padding: 0 ${rem(15)};
`;

const Col = styled.div`
  flex: 1 0 100%;

  ${({ theme }) => theme.media('sm')} {
    flex: 1 0 50%;
  }

  ${({ theme }) => theme.media('lg')} {
    flex: 1 0 33%;
  }
`;
*/

const P = styled.div`
  display: inline-block;
  align-self: center;
  margin: 0;

  &.success {
    color: ${({ theme }) => theme.color.success};
  }

  &.error {
    color: ${({ theme }) => theme.color.error};
  }
`;
/*
const PLink = styled(Link)`
  display: block;
  color: ${({ theme }) => theme.color.black};
  margin-left: ${rem(34)};
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;
*/

const TextWrapper = styled.div`
  text-align: center;
  padding-bottom: ${rem(8)};

  ${({ theme }) => theme.media('sm')} {
    text-align: initial;
    display: flex;
  }
`;

const GiftIcon = styled(IconLazy)`
  ${({ theme }) => theme.size(48)};
  fill: ${({ theme }) => theme.color.success};
  margin-right: ${rem(15)};
`;

/*
const RadioStyledStyled = styled(RadioStyled)`
  ${({ theme }) => theme.media('md')} {
    padding-bottom: 0;
    padding-top: 0;
  }
`;
*/

const GiftText = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;

const photosPlaceholder = ['images/placeholder-520.jpg'];

const GalleryModal = loadable(() => import('../_helpers/Modal/GalleryModal'));

interface CartGiftProps {
  cart: any;
  dispatch: any;
  product?: any;
  productLoading?: boolean;
  settings?: any;
}

const CartGift = (props: CartGiftProps) => {
  const [galleryProductId, setGalleryProductId] = React.useState(undefined);
  const [loading, setLoading] = React.useState(false);

  const { cart, dispatch, product, productLoading, settings } = props;

  const chosenGift = cart?.chosen_gift;
  const remain = getGiftCartRemain(cart);

  let photos = prop(product, `${galleryProductId}.photogallery`, []);
  if (!photos.length) {
    photos = photosPlaceholder;
  }

  React.useEffect(() => {
    async function handleCartgift() {
      if (remain > 0 && chosenGift) {
        const newCart = {
          ...cart,
          chosen_gift: undefined,
        };

        setLoading(true);
        await dispatch(updateCart(newCart));
        setLoading(false);
      }
    }

    handleCartgift();
  }, [cart]);

  const onGiftTextClick = () => {
    props.dispatch(setArticleModal(getGiftWebContentIdFromSettings(settings)));
  };

  /*
  const openGallery = (productId) => {
    dispatch(loadProduct(productId));
    setGalleryProductId(productId);
  };
  */

  const closeGallery = () => {
    setGalleryProductId(undefined);
  };

  return (
    <>
      <Loader loading={loading}>
        <Wrapper>
          <TextWrapper>
            <GiftIcon icon="gift" />
            <P>
              <strong>
                {__('Rozdávame')}{' '}
                <GiftText onClick={onGiftTextClick}>{__('darčeky')}</GiftText>{' '}
                {__('na podporu vzdelávania.')}
              </strong>{' '}
              <br />
              {remain > 0 ? (
                <>
                  {__('Nakúpte za')}{' '}
                  <P className={'error'}>
                    {__('ďalších')}{' '}
                    <strong>{formatPrice(remain, 'EUR')}</strong>
                  </P>{' '}
                  {__('a získate')}{' '}
                  <P className={'success'}>
                    <strong>{__('darček zadarmo.')}</strong>
                  </P>{' '}
                </>
              ) : (
                ''
              )}
            </P>
          </TextWrapper>
        </Wrapper>
      </Loader>
      {galleryProductId &&
        (productLoading ? (
          <Overlay>
            <Loader loading={productLoading} />
          </Overlay>
        ) : (
          <GalleryModal
            pictures={photos}
            activeIndex={0}
            onCloseButtonClick={closeGallery}
          />
        ))}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    product: state.general.product,
    productLoading: state.general.productLoading,
    settings: state.general.settings,
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'CartGift' })(CartGift),
);
